module.exports = __webpack_public_path__ + "static/img/0.e5382cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/good-fresh/fresh-images/0.jpg
// module id = crRO
// module chunks = 1